import axios from "axios";
import { useEffect, useState } from "react";
import { BiLockOpen } from "react-icons/bi";
import { GrMail } from "react-icons/gr";
import { MdAccountCircle, MdOutlineAlternateEmail } from "react-icons/md";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { BsPersonCircle } from "react-icons/bs";
import { AiFillEyeInvisible } from "react-icons/ai";
import { Button, Tooltip } from "@mui/material";
import "./AdminProfileUpdate.css";

const AdminProfileUpdate = () => {
  const { id } = useParams();
  const [onLoading, setonLoading] = useState(false);
  const navigate = useNavigate();
  // console.log(id.id);

  const [valueProfilePhn, setValueProfilePhn] = useState();
  const [image, setImage] = useState();
  const [imagePreview, setImagePreview] = useState();
  const [visibleCPassword, setVisibleCPassword] = useState(false);
  const [visibleEnPassword, setVisibleEnPassword] = useState(false);
  const [visibleCnPassword, setVisibleCnPassword] = useState(false);
  const [singleAdmin, setSingleAdmin] = useState({});
  const [currentPasswordPro, setCurrentPasswordPro] = useState("");
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  console.log(userName, "USER NAME");
  useEffect(() => {
    if (id) {
      axios
        .get(`https://backend.galarace.ai/api/v1/admin/${id}`)
        .then((res) => {
          setSingleAdmin(res.data.admin);
          setEmail(res.data.admin.email);
          setUserName(
            res.data.admin.username !== "undefined"
              ? res.data.admin.username
              : ""
          );
          setValueProfilePhn(res.data.admin.phone);
          setCurrentPasswordPro(res.data.admin.password);
          setImage(res.data.admin.avatar);
        });
    }
  }, [id]);

  // if (onLoading) {
  //     return <Loader />
  // }

  const subProfile = async (event) => {
    event.preventDefault();
    const name = event.target.name.value;
    const userName = event.target.username.value;
    const phone = valueProfilePhn;
    const currentPassword = event.target.currentPassword.value;
    const password = event.target.password.value;
    const cPassword = event.target.cPassword.value;
    const avatar = event.target.avatar.files[0];

    const formDataSingleAdmin = new FormData();
    formDataSingleAdmin.append("name", name);
    formDataSingleAdmin.append("username", userName);
    formDataSingleAdmin.append("email", email);
    formDataSingleAdmin.append("phone", phone);
    formDataSingleAdmin.append("password", password);
    // formDataSingleAdmin.append('newPassword', newPassword)
    // formDataSingleAdmin.append('cPassword', cPassword)
    formDataSingleAdmin.append("image", avatar);
    console.log(...formDataSingleAdmin);
    setonLoading(true);

    if (password === cPassword) {
      await axios
        .put(
          `https://backend.galarace.ai/api/v1/admin/update/${id}`,
          formDataSingleAdmin,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("admingalagames")}`,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.status === 200) {
            // alert(res.data.message);
            swal({
              // title: "Success",
              text: res.data.message,
              icon: "success",
              button: "OK!",
              className: "modal_class_success",
            });
            setonLoading(false);
            setSingleAdmin(res.data.admin);
            navigate("/admin/admins");
          }
        })
        .catch((error) => {
          // alert(error.response.data.message);
          swal({
            title: "Attention",
            text: `${error.response.data.message}`,
            icon: "warning",
            button: "OK!",
            className: "modal_class_success",
          });
          setonLoading(false);
        });
    } else {
      swal({
        title: "Attention",
        text: "Password does not matched",
        icon: "warning",
        button: "OK!",
        className: "modal_class_success",
      });
    }
  };
  return (
    <>
      <div className=" ">
        <h5 className="dashboard-title">Update Profile</h5>
        <form onSubmit={subProfile}>
          <div className="profileDiv">
            <div className="row mx-auto gx-5">
              <div className="col-lg-7 p-2">
                <p className="d-flex col-12 inputProfile">
                <Tooltip title="Full Name" placement="top">
                  <span className="iconCreator">
                    <MdAccountCircle className="text-light" />
                  </span>
                  </Tooltip>
                  <input
                    className="creatorsInput form-control"
                    type="text"
                    name="name"
                    placeholder="Admin Name"
                    defaultValue={singleAdmin?.name}
                  />
                </p>
                <p className="d-flex col-12 inputProfile">
                <Tooltip title="Username" placement="top">
                  <span className="iconCreator text-white">
                    <MdOutlineAlternateEmail className="text-light" />
                  </span>
                </Tooltip>
                  <input
                    className="creatorsInput form-control"
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={userName}
                    onChange={(e) =>
                      setUserName(e.target.value.toLocaleLowerCase())
                    }
                  />
                </p>
                <p className="d-flex col-12 inputProfile">
                <Tooltip title="Email address" placement="top">
                  <span className="iconCreator">
                    <GrMail className="text-light" />
                  </span>
                  </Tooltip>
                  <input
                    className="creatorsInput form-control"
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value.toLocaleLowerCase())
                    }
                  />
                </p>
                <p className="d-flex col-12 inputProfile">
                {/* <Tooltip title="Phone number" placement="top"> */}
                  <PhoneInput
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="SG"
                    value={valueProfilePhn}
                    onChange={setValueProfilePhn}
                    className="countryInput input_phone form-control text-white ps-1"
                  />
                {/* </Tooltip> */}
                </p>
                <p className="d-flex col-12 inputProfile">
                  <span className="inputWpass">
                   <Tooltip title="Current Password" placement="top">
                    <span className="iconCreator">
                      <BiLockOpen className="text-light" />
                    </span>
                    </Tooltip>
                    <input
                      className="creatorsInput1 password_input form-control"
                      type={visibleCPassword ? "text" : "password"}
                      name="currentPassword"
                      placeholder="Current Password"
                    />
                    <button
                      type="button"
                      onClick={() => setVisibleCPassword(!visibleCPassword)}
                      className="iconBoxBtn password_togoler text-center text-white"
                    >
                      <AiFillEyeInvisible size={25} />
                    </button>
                  </span>
                </p>
                <p className="d-flex col-12 inputProfile">
                  <span className="inputWpass">
                   <Tooltip title="New Password" placement="top">
                    <span className="iconCreator">
                      <BiLockOpen className="text-light" />
                    </span>
                    </Tooltip>
                    <input
                      className="creatorsInput1 password_input form-control"
                      type={visibleEnPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter New Password"
                    />
                    <button
                      type="button"
                      onClick={() => setVisibleEnPassword(!visibleEnPassword)}
                      className="iconBoxBtn password_togoler text-center text-white"
                    >
                      <AiFillEyeInvisible size={25} />
                    </button>
                  </span>
                </p>
                <p className="d-flex col-12 inputProfile">
                  <span className="inputWpass">
                  <Tooltip title="Confirm New Password" placement="top">
                    <span className="iconCreator">
                      <BiLockOpen className="text-light" />
                    </span>
                    </Tooltip>
                    <input
                      className="creatorsInput1 password_input form-control"
                      type={visibleCnPassword ? "text" : "password"}
                      name="cPassword"
                      placeholder="Confirm New Password"
                    />
                    <button
                      type="button"
                      onClick={() => setVisibleCnPassword(!visibleCnPassword)}
                      className="password_togoler iconBoxBtn text-white text-center"
                    >
                      <AiFillEyeInvisible size={25} />
                    </button>
                  </span>
                </p>
              </div>
              <div className="col-lg-5 text-center">
                {/* <BsPersonCircle size={40} color='#fff' /> */}
                {imagePreview ? (
                  <img
                    className="ProfileImg"
                    src={URL.createObjectURL(imagePreview)}
                    alt="avatar"
                  />
                ) : (
                  <img className="ProfileImg" src={image} alt="avatar" />
                )}
                <br />
                <input
                  onChange={(e) => setImagePreview(e.target.files[0])}
                  type="file"
                  className="ImageInput form-control"
                  name="avatar"
                />
              </div>
            </div>
            <div className="row mt-3 " style={{ padding: "0px 15%" }}>
              <div className="col-6">
                <Link className="text-decoration-none" to="/admin/admins">
                  <Button
                    type="submit"
                    sx={{
                      width: "100%",
                      borderRadius: "0px",
                      background: "#15407F",
                      marginRight: "10px",
                      fontWeight: "500",
                      "&:hover": { background: "#15407F" },
                      color: "#fff",
                      padding: "8px 10px",
                    }}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                </Link>
              </div>
              <div className="col-6">
                <Button
                  sx={{
                    width: "100%",
                    borderRadius: "0px",
                    background: "#FF5421",
                    marginRight: "10px",
                    fontWeight: "500",
                    "&:hover": { background: "#FF5421" },
                    color: "#fff",
                    paddingLeft: "5px",
                    padding: "8px 10px",
                  }}
                  variant="contained"
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AdminProfileUpdate;
